import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getpastConfYears } from '../../services/pastConfGalleryServices';
import { Button, Modal, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import {validateFile} from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const PastconfGallery = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});  
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null, 
    uploadedfile1: null,  
    year: '', 
    alt_img_name: ''
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setselectedData] = useState(null);
  const [pastConfYears, setpastConfYears] = useState([]);  
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);


  // Fetch data from API
      const fetchData = useCallback(async () => {
        setLoading(true); 
        try{
        const response = await getData();
        setData(response);
        }
        catch(error){
          console.error('Error fetching data:', error);
          toast.error('Error fetching data');
        }
        finally {
         setTimeout(() => {
          setLoading(false);
        }, 500);
        }
      }, []);
  
      useEffect(() => {
        fetchData();
      }, [fetchData]);
  
  useEffect(() => {
      const fetchpastConfYears = async () => {
        try {
          const data = await getpastConfYears(); // Fetch data from the service
          setpastConfYears(data); // Set the types in state
        } catch (error) {
          console.error('Error fetching  type:', error);
        }
      };
      fetchpastConfYears();
    }, []);

    // Validate file and input
    const validateForm = () => {
    const newErrors = {};
    if (!formData.uploadedfile ) {
      if (!errors.uploadedfile) newErrors.uploadedfile = "Preview Image is required";
    }
    if (!formData.uploadedfile1 ) {
      if (!errors.uploadedfile1) newErrors.uploadedfile1 = "Gallery Image is required";
    }
    if (!formData.year) newErrors.year = "Year is required";
    if (!formData.alt_img_name) newErrors.alt_img_name = "Alt Img Title is required";
    if (formData.alt_img_name && formData.alt_img_name.length > 50) {
      newErrors.alt_img_name = "Alt name must be less than 50 characters";
    }
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };
    

    // Handle file selection
    const handleChange = async (e) => {
      try {
        const { name, value, files } = e.target;
         const file = files?.[0];
         // Create a copy of the current form data
        let updatedData = { ...formData };  
        let updatedErrors = { ...errors };
          if (file) {
            const fileType = file.type.includes("image") ? "img" : "pdf";
            const isValid = await validateFile(file, setErrors,name, fileType);
            if (isValid) {
              updatedData[name] = file;
              updatedErrors[name] = '';
            }
            else {
              return ;
            }
          }
          else{
            updatedData[name] = value;
            if (value) {
                updatedErrors[name] = ''; // Clear error if corrected
              }
          }
          setFormData(updatedData);
          setErrors(updatedErrors);
        
        } catch (error) {
          console.log('error',error)
        }
      };

    const handleSubmit = async (e) => {
      try{
      e.preventDefault();
      if (!validateForm()) {
        return
      }
      const form = new FormData();
      form.append('id', formData.id);
      form.append('year', formData.year);
      form.append('alt_img_name', formData.alt_img_name);
      form.append('uploadedfile', formData.uploadedfile);
      form.append('uploadedfile1', formData.uploadedfile1);
      if (modalType === 'add') {
        const result = await addData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Saved Successfully!", {
              position: 'top-right',
              autoClose: 3000,
            });
        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {
                                    position: 'top-right',
                                  });
        }
      } else if (modalType === 'edit') {
        const result = await updateData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Updated Successfully!", {
              position: 'top-right',
              autoClose: 3000,
            });
        } else {
          alert('Failed to update data');toast.error(result.message ||"Failed to update data. Please try again.", {
                                    position: 'top-right',
                                  });
        }
      }
    }
    catch(error){
      console.error("Error in handleChange:", error);
    }
    };

    const handleDelete = async () => {
      try{
      if (selectedData) {
        const result = await deleteData(selectedData.id);
        if (result.status === 200) {
          fetchData();
          setShowDeleteConfirmModal(false);
          toast.success("Deleted successfully!", {
              position: 'top-right',
              autoClose: 3000,
            });
        } else {
          toast.error("Failed to delete getData:", {
              position: 'top-right',
              autoClose: 3000,
            });
        }
      }
    }
    catch(error){ 
        console.error('Error deleting data:', error);
      }
    };
  
  
  
    const openModal = (type, data = {
        id: null,
        uploadedfile: null,
        uploadedfile1: null,
        year: '', 
        alt_img_name: ''
      }) => {
        setModalType(type);
        setFormData(data);
        setShowModal(true);
      };
    

  const closeModal = () => {
    setShowModal(false);
  };

  const openDeleteConfirmModal = (data) => {
    setselectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
    setselectedData(null);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


   // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
        const filtered = data.filter(
          (data) =>
          data.alt_img_name.toLowerCase().includes(searchText.toLowerCase()) 
        );
        const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        return sortedData;
      }, [data, searchText]);
    

  const columns = [
    {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
      },
      {
        name: 'Year',
        selector: (row) => row.year,
        sortable: true,
    },
    
     {
        name: ' Preview Image',
        selector: (row) => <img src={row.gallery_thumbnail} width="100" alt={row.gallery_thumbnail}  style={{ width: '60px', height: '40px', objectFit: 'cover' }}
                crossOrigin="anonymous"/>,
        sortable: false,

    },
    {
        name: 'Alt Name',
        selector: (row) => row.alt_img_name,
        cell: (row) => (
            <span title={row.alt_img_name}>
              {row.alt_img_name}
            </span>
          ),
        sortable: true,
    },
    {
        name: ' Actual Image ',
        selector: (row) => <img src={row.gallery_pic} width="100" alt={row.gallery_pic} style={{ width: '60px', height: '40px', objectFit: 'cover' }}
                crossOrigin="anonymous" />,
        sortable: false,
    },
    
    {
      name: 'Actions',
      cell: (row) => (
                <div>
                  <Button
                    className="me-2"
                    variant="warning"
                    size="sm"
                    onClick={() => openModal('edit', {
                      id: row.id,
                      uploadedfile: row.gallery_thumbnail, 
                      uploadedfile1: row.gallery_pic,
                      year: row.year, 
                      alt_img_name: row.alt_img_name, 
                    })}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => openDeleteConfirmModal(row)}
                  >
                    Delete
                  </Button>
                </div>
              ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4">Past Events Pages / Past Conferences <b>/ Conference Gallery</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 " onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
      

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} className="modal-lg" onHide={closeModal}  backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <div className='row'>
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>Past Conference Year <small className='text-danger'> * </small></Form.Label>
                    <Form.Control className="form-select mb-3" as="select" name="year" value={formData.year} onChange={handleChange} isInvalid={!!errors.year} >
                        <option value="">Select Year</option>
                        {pastConfYears.map((years) => (
                            <option key={years.year} value={years.year}>
                            {years.display_year}
                            </option>
                        ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                    {errors.year}
                </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Alt Img Title<small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                    type="text"
                    name="alt_img_name"
                    value={formData.alt_img_name}
                    onChange={handleChange}
                    isInvalid={!!errors.alt_img_name}
                  />
                <Form.Control.Feedback type="invalid">
                    {errors.alt_img_name}
                  </Form.Control.Feedback>
                </Form.Group>                        
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>
                    Preview Image <small className='text-danger'> * </small><small className="text-primary">  (Dimension: 300x170 | Size: 10kb-50kb)</small>
                    </Form.Label>
                    <Form.Control
                        type="file"
                        name="uploadedfile"
                        onChange={handleChange}
                        isInvalid={!!errors.uploadedfile}
                    />
                      <Form.Control.Feedback type="invalid">
                        {errors.uploadedfile}
                    </Form.Control.Feedback> 
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>
                    Gallery Image <small className='text-danger'> * </small><small className="text-primary"> (Dimension: 1980x1080 | Size: 150kb-500kb)</small>
                    </Form.Label>
                    <Form.Control
                        type="file" 
                        name="uploadedfile1"
                        onChange={handleChange}
                        isInvalid={!!errors.uploadedfile1}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.uploadedfile1}
                    </Form.Control.Feedback>
                </Form.Group>                                
                </div>
                <Modal.Footer className='border-0'>
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {modalType === 'add' ? 'Add' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeDeleteConfirmModal}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>)}
      </div>
    </div>
  );
};

export default PastconfGallery;